
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ConsentPage = lazy(() => import('../pages/consent/page'));
const HealthCheckPage = lazy(() => import('../pages/health-check/page'));
const ResultsPage = lazy(() => import('../pages/results/page'));
const NextStepsPage = lazy(() => import('../pages/next-steps/page'));
const AwarenessPage = lazy(() => import('../pages/awareness/page'));
const PreventionPage = lazy(() => import('../pages/prevention/page'));
const DataInsightsPage = lazy(() => import('../pages/data-insights/page'));
const HospitalDirectoryPage = lazy(() => import('../pages/hospital-directory/page'));
const EmergencyPage = lazy(() => import('../pages/emergency/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/consent',
    element: <ConsentPage />,
  },
  {
    path: '/health-check',
    element: <HealthCheckPage />,
  },
  {
    path: '/results',
    element: <ResultsPage />,
  },
  {
    path: '/next-steps',
    element: <NextStepsPage />,
  },
  {
    path: '/awareness',
    element: <AwarenessPage />,
  },
  {
    path: '/prevention',
    element: <PreventionPage />,
  },
  {
    path: '/data-insights',
    element: <DataInsightsPage />,
  },
  {
    path: '/hospital-directory',
    element: <HospitalDirectoryPage />,
  },
  {
    path: '/emergency',
    element: <EmergencyPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
